import { render, staticRenderFns } from "./BasePartnerLogo.vue?vue&type=template&id=d481b490&scoped=true&"
import script from "./BasePartnerLogo.vue?vue&type=script&lang=js&"
export * from "./BasePartnerLogo.vue?vue&type=script&lang=js&"
import style0 from "./BasePartnerLogo.vue?vue&type=style&index=0&id=d481b490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d481b490",
  null
  
)

export default component.exports